<template>
  <div class="relevance-container">
    <div class="create-student" @click="createNewStudent">
      <img src="../../images/mall/create_student.png" alt="">
      <span class="text">创建新学员</span>
    </div>
    <div class="checklist-wrapper">
      <div class="all-checked">
        <yd-checkbox
          shape="circle"
          color="#FF7819"
          :value="allChecked"
          @click.native.prevent="handleCheckAll"
        >全选</yd-checkbox>
      </div>
      <div class="check-list">
        <div v-for="(student, index) in studentList" :key="student.studentId" class="checkbox-item-wrap">
          <div class="item-left">
            <yd-checkbox
              shape="circle"
              color="#FF7819"
              :value="student.checked"
              @input="handleChecked($event, index)"
            >&nbsp;</yd-checkbox>
          </div>
          <div class="item-right">
            <div class="student-name">{{student.studentName}}</div>
            <div class="student-phone">{{student.studentVOList[0].phone}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button :disabled="disabled" class="btn-confirm" @click="handleConfirm">确认添加</button>
    </div>
  </div>
</template>
<script>
import User from "@/core/user";

export default {
  computed: {
    disabled() {
      return this.studentList.every(item => !item.checked);
    },
    allChecked: function() {
      return this.studentList.every(item => item.checked);
    }
  },
  data() {
    return {
      instId: window.getParameterByName("instId"),
      allSelect: '全选',
      studentList: []
    }
  },
  methods: {
    createNewStudent() {
      this.$route.params.action = 'create';
      this.$router.back();
    },
    getBindAbleList() {
      const studentList = JSON.parse(this.$route.query.studentList);

      studentList.map(item => {
        item.checked = true;
      });

      this.studentList = studentList;
      console.log('--------studentList--------', studentList);
    },
    handleCheckAll() {
      const checked = !this.allChecked;
      const list = JSON.parse(JSON.stringify(this.studentList));

      list.map(item => {
        item.checked = checked;
      });
      console.log('--------list--------', list, checked);
      this.studentList = list;
    },
    handleChecked(checked, index) {
      this.studentList[index].checked = checked;
    },
    ajaxConfirm(studentIds) {
      const params = {
        appId: User.appId(),
        notWechatPlatform: false,
        studentIds,
        userId: User.uid() || ''
      };

      return axios.Customer("public/groupToStudent/createNew", params);
    },
    async handleConfirm() {
      const selected = this.studentList.filter(item => item.checked);
      const studentArr = selected.map(item => {
        const { instId, studentId, name, phone } = item.studentVOList[0];

        return {
          instId,
          studentId,
          studentName: name,
          phone
        };
      });
      const studentIds = studentArr.map(item => item.studentId);
      const result = await this.ajaxConfirm(studentIds);

      if (result.success) {
        this.$route.params.action = 'add';
        this.$route.params.studentArr = studentArr;
        this.$router.back();
      } else {
        Vue.$wheatToast(result.message);
      }
    }
  },
  mounted() {
    console.log('--------mounted--------');
    this.getBindAbleList();
  }
}
</script>
<style lang="less">
@import "../../core/mixins.less";

.relevance-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .create-student {
    height: 1.174rem;
    line-height: 1.174rem;
    background: #ffffff;
    img {
      width: 0.534rem;
      height: 0.534rem;
      vertical-align: middle;
    }
    .text {
      display: inline-block;
      margin-left: 0.2rem;
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 0.4rem;
      text-align: left;
      vertical-align: middle;
    }
  }
  .checklist-wrapper {
    display: flex;
    flex-direction: column;
    overflow: auto;
    .all-checked {
      padding: 0.28rem 0.38rem;
      text-align: left;
      .yd-checkbox {
        .yd-checkbox-icon {
          margin-right: 0.2rem;
          vertical-align: text-bottom;
        }
      }
    }
    .check-list {
      margin-bottom: 1.5rem;
      overflow: auto;
      .checkbox-item-wrap {
        display: flex;
        align-items: center;
        padding: 0.28rem 0.38rem;
        border-bottom: 1px solid #fafafa;
        background: #ffffff;
        .yd-checkbox>input[type=checkbox] {
          width: 0;
        }
        .item-left {
          flex: 0 0 1rem;
        }
        .item-right {
          width: 90%;
          text-align: left;
          .student-name {
            color: #333;
            font-size: 0.36rem;
            .text-overflow-ellipsis();
          }
          .student-phone {
            color: #999;
            font-size: 0.3rem;
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    padding: 0.24rem 0.38rem;
    width: 100%;
    bottom: 0;
    text-align: center;
    font-size: 0.36rem;
    border-top: 1px solid #fafafa;
    background: #ffffff;
    z-index: 1000;
    .btn-confirm {
      padding: 0.28rem 0;
      width: 100%;
      color: #ffffff;
      background: linear-gradient(to right, #ff7819, #ff4200);
      border-radius: 5px;
      border: 0 none;
      &[disabled] {
        opacity: 0.3;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/mall/Relevance.vue